'use client'

import { ProductDetailsInfosSection } from '@/feature/product/components/product-details-section/ProductDetailsInfosSection.client'
import { ProductTechnicalSpecs } from '@/feature/product/components/product-technical-specs/ProductTechnicalSpecs.client'
import { useProductInfos } from '@/feature/product/hooks/useProductInfos'
import {
  TECHNICAL_SPECS_ANCHOR_ID,
  TECHNICAL_SPECS_ANCHOR_THRESHOLD,
} from '@/feature/product/services/product.constants'
import { useTranslation } from '@/lib/i18n/useTranslation.client'
import { Title } from '@/ui/text/title/Title'
import type { ProductTechnicalSpecsFull_ProductFragment } from '@gql-generated/graphql'

type ProductTechnicalSpecsFullContentProps = {
  product: ProductTechnicalSpecsFull_ProductFragment
}

/**
 * Render the full technical specifications of a product, including norms if available and keep
 * them in sync with the selected reference.
 */
export function ProductTechnicalSpecsFullClient({
  product,
}: ProductTechnicalSpecsFullContentProps) {
  const { t } = useTranslation(['productPage'])
  const { activeProduct } = useProductInfos({ product })
  const { technicalSpecs, norms } = activeProduct

  if (
    !technicalSpecs?.length ||
    (technicalSpecs.length <= TECHNICAL_SPECS_ANCHOR_THRESHOLD && !norms?.length)
  )
    return null

  return (
    <ProductDetailsInfosSection withDivider={false} id={TECHNICAL_SPECS_ANCHOR_ID}>
      <Title size="2xl" as="h2" className="font-bold">
        {t('productPage:technicalSpecs.title')}
      </Title>
      <ProductTechnicalSpecs technicalSpecs={technicalSpecs} norms={norms} />
    </ProductDetailsInfosSection>
  )
}
